import React, { Component } from 'react';
import { withRouter } from 'next/router';
import { connect } from 'react-redux';
import cn from 'classnames';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import styles from './Sidebar.module.scss';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

import { showModal, updateModalProps } from 'legacy/actions/modalActions';
import { sendMoneyFlow } from '../../../util/modalFlows';

import { logEvent } from 'legacy/common/utils/amplitude';
import {
  EVENT_CLICK_CREATE_EVENT,
  EVENT_CLICK_CREATE_ORG,
  EVENT_CLICK_REQUEST_MONEY,
  EVENT_CLICK_SEND_MONEY
} from 'legacy/common/constants/events';

// Simplified props type
type SidebarProps = any;

class Sidebar extends Component<SidebarProps> {
  constructor(props: SidebarProps) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(prevProps: SidebarProps) {
    const { modalType, friends } = this.props;
    if (
      modalType === 'SELECT_FRIEND' &&
      !_.isEqual(prevProps.friends, friends)
    ) {
      this.props.updateModalProps({ users: friends });
    }
  }

  sendMoney = (receiver: any) =>
    sendMoneyFlow(() => this.props.showModal('SEND_MONEY', { receiver }));

  requestMoney = (sender: any) => this.props.showModal('REQUEST_MONEY', { sender });

  render() {
    const { t } = this.props;
    const path = this.props.router.pathname;

    const sendMoney = (
      <div className="inner-content">
        <div className="bg-transfer" />
        <img id="transfer-img" src="/img/illustrations/parachute.svg" alt="" />
        <div className="transfer-body">
          <h4>{t('actions.sendFriendMoney')}</h4>

          <Button
            type={ButtonType.Primary}
            onClick={() => {
              logEvent(EVENT_CLICK_SEND_MONEY, { url: path });
              this.props.showModal('SELECT_FRIEND', {
                users: this.props.friends,
                onSelect: (user) => {
                  this.sendMoney(user);
                },
                message: 'Select a user to send money to.'
              });
            }}
          >
            {t('actions.sendMoney')}
          </Button>
        </div>
      </div>
    );

    const requestMoney = (
      <div className="inner-content">
        <div className="bg-payout" />
        <img
          id="payout-img"
          src="/img/illustrations/requestPayout.svg"
          alt=""
        />
        <div className="payout-body">
          <h4>{t('actions.requestMoneyFromFriend')}</h4>
          <Button
            type={ButtonType.Primary}
            onClick={() => {
              logEvent(EVENT_CLICK_REQUEST_MONEY, { url: path });
              this.props.showModal('SELECT_FRIEND', {
                users: this.props.friends,
                onSelect: (user) => {
                  this.requestMoney(user);
                },
                message: 'Select a user to request money from.'
              });
            }}
          >
            {t('actions.requestMoney')}
          </Button>
        </div>
      </div>
    );

    let content;
    if (
      path === '/host' ||
      path.includes('/profile') ||
      path === '/transfers' ||
      path === '/dashboard'
    ) {
      content = (
        <>
          <div className="bn-container">{sendMoney}</div>
          <div className="bn-container">{requestMoney}</div>
          {path === '/dashboard' && (
            <>
              <div
                className={cn('bn-container', styles.createEvent)}
                onClick={() => {
                  logEvent(EVENT_CLICK_CREATE_EVENT, { url: path });
                  this.props.router.push('/host');
                }}
              >
                <div className="inner-content create">
                  {t('actions.createEvent')}
                </div>
              </div>
              <div
                className={cn('bn-container', styles.createEvent)}
                onClick={() => {
                  logEvent(EVENT_CLICK_CREATE_ORG, { url: path });
                  this.props.router.push('/organizations/create');
                }}
              >
                <div className="inner-content create">
                  {t('actions.createOrganization')}
                </div>
              </div>
            </>
          )}
        </>
      );
    }

    return <div className={styles.Sidebar}>{content}</div>;
  }
}

function mapStateToProps(state: any) {
  return {
    user: state.user.user,
    friends: state.friends.friends,
    notifications: state.notifications.list,
    unread: state.notifications.unread,
    modalType: state.modal.type
  };
}

const actions = { showModal, updateModalProps };

// Type assertion to bypass complex HOC typing issues with legacy components
export default withRouter(
  connect(mapStateToProps, actions)(withTranslation('dashboard')(Sidebar) as any)
);
